"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUpload = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _axios = _interopRequireDefault(require("axios"));

var _components = require("../../components");

var _Footer = _interopRequireDefault(require("../../layout/Footer"));

var _DocumentProvider = require("../../context/DocumentProvider");

var _parseDocument = _interopRequireDefault(require("../../lib/utils/helper/parseDocument"));

var _Global = _interopRequireDefault(require("../../styles/Global.style"));

var _reveleerLogo = _interopRequireDefault(require("../../assets/images/logo/reveleer-logo.svg"));

var _FileUpload = require("./FileUpload.style");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactRouterDom = require("react-router-dom");

// import { mockEhrRecord } from 'data/mockData';
// import sampleDocument from '../../data/MDP_HCC_V1.xml';
var removeBrands = function removeBrands(str) {
  if (typeof str !== 'string') return '';
  return str.replace(/Health Gorilla Inc./g, '');
};

var FileUpload = function FileUpload(_ref) {
  var _queryString$parse;

  var ehrRecord = _ref.ehrRecord,
      setFileName = _ref.setFileName;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 1),
      searchParams = _useSearchParams2[0];

  var cdaUrl = (_queryString$parse = _queryString.default.parse(searchParams.toString())) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.cdaUrl;

  var _useState = (0, _react.useState)(Boolean(cdaUrl)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      fileLoading = _useState2[0],
      setFileLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      fileValue = _useState4[0],
      setFileValue = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      fileError = _useState6[0],
      setFileError = _useState6[1];

  var _useContext = (0, _react.useContext)(_DocumentProvider.DocumentContext),
      setCurrentDocument = _useContext.setCurrentDocument,
      setRawDocument = _useContext.setRawDocument,
      setRecordData = _useContext.setRecordData;

  var onDrop = (0, _react.useCallback)(function (file) {
    setFileLoading(true);
    var reader = new FileReader();
    reader.readAsDataURL(file[0]);
    setFileName(file[0].name);

    reader.onload = function () {
      var b64Url = reader.result;
      var b64String = b64Url.substring(b64Url.indexOf('base64,') + 7);
      var encodedXml = decodeURIComponent(atob(b64String).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('').trim());
      encodedXml = removeBrands(encodedXml);
      setFileValue(encodedXml);
      setRawDocument(encodedXml);
    };

    reader.onerror = function (err) {
      setFileError(err);
    };
  }, []);

  var getData = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var res, parsedDocument, rawDocumentClean, _res, document;

      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!cdaUrl) {
                _context.next = 15;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return _axios.default.get(cdaUrl, {
                'Content-Type': 'application/xml'
              });

            case 4:
              res = _context.sent;
              setFileValue(res.data);
              setRawDocument(res.data);
              _context.next = 15;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.dir(_context.t0);
              setFileError('Invalid Document URL');
              setFileLoading(false);
              return _context.abrupt("return");

            case 15:
              if (!ehrRecord) {
                _context.next = 26;
                break;
              }

              setFileLoading(true);
              _context.next = 19;
              return (0, _parseDocument.default)(ehrRecord.recordXml);

            case 19:
              parsedDocument = _context.sent;
              rawDocumentClean = removeBrands(ehrRecord.recordXml);
              setRawDocument(rawDocumentClean);
              setRecordData(ehrRecord.recordData);
              setCurrentDocument(parsedDocument);
              _context.next = 44;
              break;

            case 26:
              if (!fileValue) {
                _context.next = 44;
                break;
              }

              setFileLoading(true);

              if (!fileValue.startsWith('/static')) {
                _context.next = 40;
                break;
              }

              _context.prev = 29;
              _context.next = 32;
              return _axios.default.get(fileValue, {
                'Content-Type': 'application/xml'
              });

            case 32:
              _res = _context.sent;
              setRawDocument(_res.data);
              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t1 = _context["catch"](29);
              console.dir(_context.t1);
              return _context.abrupt("return");

            case 40:
              _context.next = 42;
              return (0, _parseDocument.default)(fileValue);

            case 42:
              document = _context.sent;
              setCurrentDocument(document);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9], [29, 36]]);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    // // Test data for development
    // setFileValue(sampleDocument);
    getData();
  }, [getData]);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: onDrop,
    multiple: false,
    accept: '.xml'
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Global.default, null), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fileError ? /*#__PURE__*/_react.default.createElement("p", null, "Error while uploading File: ", fileError) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fileLoading ? /*#__PURE__*/_react.default.createElement(_components.Spinner, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FileUpload.FileUploadWrapper, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FileUpload.Logo, {
    src: _reveleerLogo.default
  }), /*#__PURE__*/_react.default.createElement("div", Object.assign({
    className: "upload-container"
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement("p", null, "Click to select a CDA file (.xml file type only)")))), /*#__PURE__*/_react.default.createElement(_Footer.default, null)))));
};

exports.FileUpload = FileUpload;